import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { fetch_one, fetch_all, fetch_all_with_count } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import {
  Box,
  Button as Btn,
  Checkbox,
  Chip,
  CircularProgress,
  DialogActions,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
} from '@mui/material';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HealingIcon from '@mui/icons-material/Healing';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';
import InfoIcon from '@mui/icons-material/Info';
import MedicationIcon from '@mui/icons-material/Medication';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import SickIcon from '@mui/icons-material/Sick';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';

import {
  Button,
  DatePicker,
  Dt,
  Editor,
  FileDrop,
  IconButton,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../../components/v2/styled';
import { SnackSaved } from '../../snacks/Saved';

import { Advice } from '../../../../models/Advice';
import { Medication } from '../../../../models/Medication';
import Vaccines from '@mui/icons-material/Vaccines';
import BrunchDining from '@mui/icons-material/BrunchDining';

const { DateTime } = require("luxon");

type Props = {
  onClick: (b:boolean) => void;
  open: boolean;
  setOpen: (b:boolean) => void;
  advice: Advice;
  clonedAdvice: Advice;
  setAdvice: (d:Advice) => void;
  loading?: boolean;
  activeCompare?: Advice;
  objects?: Advice[];
};

export const CoachEditAdviceTab3: FunctionComponent<Props> = ({objects, activeCompare, loading, open, setOpen, advice, clonedAdvice, setAdvice, onClick}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const {t, i18n} = useTranslation(['translations']);

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("IF(med_type='supplement' OR med_type='medicatie' OR ISNULL(med_type)=1, ISNULL(med_end), 0) DESC, IF(med_end>NOW(), 1, 0) DESC, med_start DESC, med_end DESC");
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [showMedEnd, setShowMedEnd] = useState<boolean>(false);
  const [showHint, setShowHint] = useState<boolean>(false);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);

  const [activeMed, setActiveMed] = useState<Medication>();

  // useEffect(() => {
  //   [...(objects || [])].sort((a, b) => ((b.epi || 0) * 10000 + (b.idx || 0)) - ((a.epi || 0) * 10000 + (a.idx || 0))).forEach(obbb => {
  //     if (!!obbb.weight && (obbb.epi || 0) === (advice.epi || 0) && (obbb.idx || 0) < (advice.idx || 0)) setFirstWeight(parseFloat(obbb.weight));
  //     if (!!obbb.waist && (obbb.epi || 0) === (advice.epi || 0) && (obbb.idx || 0) < (advice.idx || 0)) setFirstWaist(parseFloat(obbb.waist));
  //   });
  //   [...(objects || [])].sort((a, b) => ((a.epi || 0) * 10000 + (a.idx || 0)) - ((b.epi || 0) * 10000 + (b.idx || 0))).forEach(obbb => {
  //     if (!!obbb.weight && (obbb.epi || 0) === (advice.epi || 0) && (obbb.idx || 0) < (advice.idx || 0)) setLastWeight(parseFloat(obbb.weight));
  //     if (!!obbb.waist && (obbb.epi || 0) === (advice.epi || 0) && (obbb.idx || 0) < (advice.idx || 0)) setLastWaist(parseFloat(obbb.waist));
  //   });
  // }, [objects]);

  const {
    data: medications,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["coach", "medications", (login?.practice_id || currentPractice?.id), {page: page, order: order}],
    queryFn: () =>
      fetch_all_with_count<Medication>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'medication',
          fields: [
            'id', 'med_start', 'med_end', 'name', 'cause', 'med_type', 'doctor_note', 'med_interval', 'comment', 'internal_comment', 'user_id', 'practice_id'
          ],
          sub_fields: {
            // 'anamnese': ['id', 'breakfast']
          },
          per_page: 1000,
          page: 0,
          order: order,
          skip_order_check: 1,
          filter: {
            search: '',
            advanced: {
              user_id: advice?.user_id,
              practice_id: currentPractice?.id
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id) && !!advice?.user_id,
  });









  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<Medication>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      objectsRefetch();
      setSavedOpen(true);
      setActiveMed(undefined);
    },
  });












  return (<>
    <IconButton onClick={() => {
      setShowHint(!showHint);
    }} sx={{
      top: 8,
      position: 'absolute',
      right: 8
    }}>
      <InfoIcon color="primary" />
    </IconButton>
    {showHint && <Grid item xs={12}>
      <Typography html sx={{
        borderRadius: 1,
        border: '1px solid transparent',
        borderColor: theme.palette.warning.main,
        padding: 2,
        textAlign: 'center'
      }}>{t("new_advices.detail.warnings.balloon_wysiwyg")}</Typography>
    </Grid>}

    <Grid item xs={12}>
      <Typography html sx={{
        borderRadius: 1,
        border: '1px solid transparent',
        borderColor: theme.palette.warning.main,
        padding: 2,
        textAlign: 'center'
      }}>{t("new_advices.detail.warnings.medication_separate")}</Typography>
    </Grid>
    <Grid item xs={12}></Grid>
    <Grid item xs={4}>
      <List
        sx={{ width: '100%', paddingTop: 0, paddingBottom: 0, maxHeight: 600, overflow: 'scroll' }}
        aria-label="medications"
      >
        <ListItem disablePadding onClick={() => {
          setFlickerEditor(true);
          setActiveMed({
            name: '',
            med_start: DateTime.now().toFormat("dd/LL/y")
          });
          setTimeout(() => {setFlickerEditor(false);}, 200);
        }}>
          <ListItemButton>
            <ListItemIcon>
              <AddCircleOutlineIcon />
            </ListItemIcon>
            <ListItemText primary={t("coach.medications.cta.add_new")} />
          </ListItemButton>
        </ListItem>

        {(medications || []).map(med => <>
          <Divider />
          <ListItem disablePadding onClick={() => {
            setFlickerEditor(true);
            setShowMedEnd(!!med.med_end);
            setActiveMed({
              ...med,
              med_start: DateTime.fromISO(med.med_start).toFormat("dd/LL/y"),
              med_end: !!med.med_end ? DateTime.fromISO(med.med_end).toFormat("dd/LL/y") : undefined
            });
            setTimeout(() => {setFlickerEditor(false);}, 200);
          }} sx={{
            backgroundColor: (
              med.med_type === 'medicatie' ? '#8FB3E0' : (
                med.med_type === 'supplement' ? '#8FB3E0' : (
                  med.med_type === 'operation' ? '#F7C48A' : (
                    med.med_type === 'treatment' ? '#B3A6D6' : (
                      med.med_type === 'research' ? '#F7C48A' : (
                        med.med_type === 'complaint' ? '#F2A08C' : (
                          med.med_type === 'important_event' ? '#F2A08C' : (
                            med.med_type === 'diet' ? '#97BE6B' : (
                              'transparent'
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          }}>
            <ListItemButton>
              {med.med_type === 'medicatie' && <ListItemIcon>
                <MedicationIcon />
              </ListItemIcon>}
              {med.med_type === 'diet' && <ListItemIcon>
                <BrunchDining />
              </ListItemIcon>}
              {med.med_type === 'supplement' && <ListItemIcon>
                <VaccinesIcon />
              </ListItemIcon>}
              {med.med_type === 'operation' && <ListItemIcon>
                <HeartBrokenIcon />
              </ListItemIcon>}
              {med.med_type === 'treatment' && <ListItemIcon>
                <HealingIcon />
              </ListItemIcon>}
              {med.med_type === 'research' && <ListItemIcon>
                <HealingIcon />
              </ListItemIcon>}
              {med.med_type === 'complaint' && <ListItemIcon>
                <SickIcon />
              </ListItemIcon>}
              {med.med_type === 'important_event' && <ListItemIcon>
                <CrisisAlertIcon />
              </ListItemIcon>}
              <ListItemText inset={!med.med_type} primary={med.name} secondary={<><Dt d={med.med_start} />{!!med.med_end && " - "}{!!med.med_end && <Dt d={med.med_end} />}</>} />
            </ListItemButton>
          </ListItem>
        </>)}
      </List>
    </Grid>
    <Grid item xs={8} sx={{borderLeft: '1px solid transparent', borderColor: theme.palette.primary.main}}>
      {!activeMed && <Typography sx={{color: 'lightgrey', fontStyle: 'italic', textAlign: 'center', minHeight: '450px'}}>{t("coach.medications.message.none_selected")}</Typography>}
      {!!activeMed && <>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="caption">{t("client.models.medications.med_start")}*</Typography>
            <DatePicker
              disableFuture={false}
              openTo="year"
              label=""
              format={"dd/LL/y"}
              views={["year", "month", "day"]}
              setValue={(e) => {
                setActiveMed({
                  ...(activeMed || {}),
                  med_start: e
                });
              }}
              value={activeMed.med_start || DateTime.now().toFormat("dd/LL/y")}
              id="option_date"
              sx={{
                box: {
                  width: 'auto',
                  display: 'inline-block'
                },
                field_box: {
                  "svg": {
                    display: 'none'
                  }
                },
                field: {
                  width: 'auto',
                  marginTop: 0,
                  "input": {
                    textAlign: 'center'
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <Typography variant="caption">{t("client.models.medications.has_med_end")}</Typography>
            <Checkbox checked={!!showMedEnd} onChange={(e) => {
              if (e.target.checked) {
                setShowMedEnd(true);
                setActiveMed({
                  ...(activeMed || {}),
                  med_end: DateTime.now().toFormat("dd/LL/y")
                });
              } else {
                setShowMedEnd(false);
                setActiveMed({
                  ...(activeMed || {}),
                  med_end: undefined
                });
              }
            }} />
          </Grid>
          <Grid item xs={4}>
            {!!showMedEnd && <Typography variant="caption">{t("client.models.medications.med_end")}</Typography>}
            {!!showMedEnd && <DatePicker
              disableFuture={false}
              openTo="year"
              label=""
              format={"dd/LL/y"}
              views={["year", "month", "day"]}
              setValue={(e) => {
                setActiveMed({
                  ...(activeMed || {}),
                  med_end: e
                });
              }}
              value={activeMed.med_end || DateTime.now().toFormat("dd/LL/y")}
              id="option_date"
              sx={{
                box: {
                  width: 'auto',
                  display: 'inline-block'
                },
                field_box: {
                  "svg": {
                    display: 'none'
                  }
                },
                field: {
                  width: 'auto',
                  marginTop: 0,
                  "input": {
                    textAlign: 'center'
                  }
                }
              }}
            />}
          </Grid>
          <Grid item xs={12}>
            <TextInput
              id="name"
              required
              starred
              caption={t("client.models.medications.name")}
              placeholder={t("client.models.medications.placeholders.name")}
              value={activeMed?.name || ""}
              onChange={(e) => {
                setActiveMed({
                  ...(activeMed || {}),
                  name: e
                });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Select
              fullWidth
              displayEmpty
              caption={t("client.models.medications.med_type")}
              id="med_type"
              value={activeMed?.med_type?.toLowerCase() || ''}
              setValue={(v) => {
                setActiveMed({
                  ...(activeMed || {}),
                  med_type: v?.toString()
                });
              }}
            >
              <MenuItem value="">--- ---</MenuItem>
              <MenuItem value="complaint">{t("client.models.medications.med_types.complaint")}</MenuItem>
              <MenuItem value="important_event">{t("client.models.medications.med_types.important_event")}</MenuItem>
              <MenuItem value="diet">{t("client.models.medications.med_types.diet")}</MenuItem>
              <MenuItem value="medicatie">{t("client.models.medications.med_types.medication")}</MenuItem>
              <MenuItem value="supplement">{t("client.models.medications.med_types.supplement")}</MenuItem>
              <MenuItem value="treatment">{t("client.models.medications.med_types.treatment")}</MenuItem>
              <MenuItem value="operation">{t("client.models.medications.med_types.operation")}</MenuItem>
              <MenuItem value="research">{t("client.models.medications.med_types.research")}</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={6}>
            <Switcher
              id="doctor_note"
              caption={t("client.models.medications.doctor_note")}
              value={!!activeMed?.doctor_note}
              onChange={(c) => {
                setActiveMed({
                  ...(activeMed || {}),
                  doctor_note: !!c
                });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            {!flickerEditor && <Editor
              advanced
              balloon
              label={t("client.models.medications.cause")}
              value={activeMed?.cause || ""}
              outside_world
              onChange={(e) => {
                setActiveMed({
                  ...(activeMed || {}),
                  cause: e
                });
              }}
            />}
          </Grid>
          <Grid item xs={6}>
            {!flickerEditor && <Editor
              advanced
              balloon
              label={t("client.models.medications.med_interval")}
              value={activeMed?.med_interval || ""}
              outside_world
              onChange={(e) => {
                setActiveMed({
                  ...(activeMed || {}),
                  med_interval: e
                });
              }}
            />}
          </Grid>
          <Grid item xs={6}>
            {!flickerEditor && <Editor
              advanced
              balloon
              label={t("client.models.medications.comment")}
              value={activeMed?.comment || ""}
              outside_world
              onChange={(e) => {
                setActiveMed({
                  ...(activeMed || {}),
                  comment: e
                });
              }}
            />}
          </Grid>
          <Grid item xs={6}>
            {!flickerEditor && (!activeMed.id || activeMed.practice_id === (currentPractice?.id || login?.practice_id)) && <Editor
              advanced
              balloon
              label={t("client.models.medications.internal_comment")}
              value={activeMed?.internal_comment || ""}
              onChange={(e) => {
                setActiveMed({
                  ...(activeMed || {}),
                  internal_comment: e
                });
              }}
            />}
            {!(!activeMed.id || activeMed.practice_id === (currentPractice?.id || login?.practice_id)) && <Typography sx={{color: 'lightgrey', fontStyle: 'italic', textAlign: 'center'}}>{t("new_advices.detail.warnings.medication_global")}</Typography>}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{marginTop: 2, marginBottom: 2}} />
          {!!mutationSave.isPending && <CircularProgress />}
          {!mutationSave.isPending && <Button
            id="save_profile"
            disabled={!activeMed.name || !activeMed.med_start}
            contained
            onClick={(e) => {
              mutationSave.mutate({
                formData: {
                  object: 'medication',
                  fields: ['id'],
                  id: activeMed?.id,
                  ob: {
                    ...activeMed,
                    user_id: advice?.user_id,
                    ...(!!activeMed?.id ? {} : {
                      practice_id: (currentPractice?.id || login?.practice_id)
                    })
                  }
                }
              });
            }}
            label={t("client.general.buttons.submit", "Opslaan")}
            sx={{
              marginTop: 1
            }}
          />}
          <Button
            id="cancel"
            onClick={(e) => {
              setActiveMed(undefined);
            }}
            label={t("coach.general.actions.cancel")}
            sx={{
              marginTop: 1,
              marginLeft: 1
            }}
          />
        </Grid>
      </>}
    </Grid>

    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </>);
}
